module.exports = __webpack_public_path__ + "img/bc.325e267b.png";